import { render } from "./YesOrNoInput.vue?vue&type=template&id=09da81b2"
import script from "./YesOrNoInput.vue?vue&type=script&lang=js"
export * from "./YesOrNoInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__